import files from "../../api/files";

export default {
  namespaced: true,
  state: {
    items: [],
    editedId: -1,
    editedItem: {
      fileName: "",
      contentType: "",
      docType: 0,
      filePath: "",
      fileSize: 0,
      uploadDate: null,
      updatedById: null,
    },
    defaultItem: {
      fileName: "",
      contentType: "",
      docType: 0,
      filePath: "",
      fileSize: 0,
      uploadDate: null,
      updatedById: null,
    },
  },
  mutations: {
    setItems(state, items) {
      state.items = items;
    },
    setEditedItem(state, item) {
      const editedItem = {
        fileName: item.fileName,
        contentType: item.contentType,
        docType: item.docType,
        filePath: item.filePath,
        fileSize: item.fileSize,
        uploadDate: item.uploadDate,
        updatedById: item.updatedById,
      };
      state.editedItem = editedItem;
    },
    setEditedId(state, id) {
      state.editedId = id;
    },
  },
  actions: {
    fetchAll({ commit }, data) {
      return files.get(data).then((response) => {
        commit("setItems", response.data);
        return response;
      });
    },
    uploadFile({ dispatch }, formData) {
      const data = formData.data;
      const customerNumbers = formData.customerNumbers;
      const contractId = formData.contractId;
      const docType = formData.docType;
      return files
        .store(data, customerNumbers, contractId, docType)
        .then((response) => {
          dispatch("getFilesForSpecificContract", {
            customerNumbers,
            contractId,
          });
          return response;
        });
    },
    getFilesForSpecificCustomer({ commit }, customerId) {
      return files.getByCustomer(customerId).then((response) => {
        commit("setItems", response.data);
        return response;
      });
    },
    getFilesForSpecificContract({ commit }, data) {
      return files.get(data).then((response) => {
        const filteredData = response.data.filter((item) => item.docType === 1);
        commit("setItems", filteredData);
        return response;
      });
    },
    downloadFile(context, id) {
      return files.downloadFile(id);
    },
    deleteFile({ dispatch }, data) {
      return files.delete(data.id).then((response) => {
        if (data.customerNumbers && data.customerNumbers.length > 0) {
          const dataToSend = {
            customerNumbers: data.customerNumbers,
            contractId: data.id,
          };
          dispatch("getFilesForSpecificContract", dataToSend);
        } else {
          dispatch("fetchAll");
        }
        return response;
      });
    },
    resetEditedItem({ commit, state }) {
      commit("setEditedId", -1);
      commit("setItems", []);
      commit("setEditedItem", Object.assign({}, state.defaultItem));
    },
  },
};
